export default {
  storeNamespace: 'reference',
  authFeature: 'reference',
  detailRouteName: "ReferenceMobileDetail",
  useNewModal: true,
  titleField: 'internal_code',
  fields: [{
      name: 'internal_code',
      label: "Code interne",
      type: 'text',
      inDetail: true,
    },
    {
      name: 'product',
      label: "Produit",
      type: 'select',
      inDetail: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'supplier',
      label: "Fournisseur",
      type: 'select',
      inDetail: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'brand',
      label: "Marque",
      type: 'text',
      inDetail: true,
    },
    {
      name: 'model',
      label: "Modèle",
      type: 'text',
      inDetail: true,
    },
    {
      name: 'serial_number',
      label: "Numéro de série",
      type: 'text',
      inDetail: true,
    },
    {
      name: 'comment',
      label: "Commentaire",
      type: 'textarea',
      inDetail: true,
    },
    {
      name: 'purchase_date',
      label: "Date d'achat",
      type: 'date',
      inDetail: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'purchase_price',
      label: "Prix d'achat HT",
      type: 'number',
      inDetail: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inDetail: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'first_maintenance_date',
      label: "Date de première maintenance",
      type: 'date',
      inDetail: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'last_maintenance_date',
      label: "Date de dèrnière maintenance",
      type: 'date',
      inDetail: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'total_rental_amount',
      label: "Montant total des location",
      type: 'number',
      inDetail: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
    },
    {
      name: 'total_rental_days',
      label: "Nombre total de jours loué",
      type: 'number',
      inForm: false,
      inDetail: true,
    },
    {
      name: 'reference_total_cost',
      label: "Coup total",
      type: 'number',
      inDetail: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inDetail: true,
      formatter: (context, value) => value ? value ? context.$moment(value).format("dddd, DD MMMM YYYY") : null : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inDetail: true,
      formatter: (context, value) => value ? value ? context.$moment(value).format("dddd, DD MMMM YYYY") : null : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/ReferenceMobile/config.js